export const launchIntercom = () => {
  if (typeof window !== 'undefined') {
    if (window.Intercom) window.Intercom('show');
    else {
      window.alert(
        'Ad blocking plug-in detected - Messenger unable to launch. While our Messenger does not include third-party advertisements, the Messenger powered by Intercom does offer helpful articles, news, tooltips, and provides you with direct connection to one of our dedicated Investor Relations Specialists. To access the Messenger, please remove EquityMultiple from your block list.',
      );
    }
  }
};
